<template>
  <div>
    <Navbar/>

    <main>
      <slot/>
    </main>

    <Footer/>
  </div>
</template>

<script>
import Navbar from '../components/layout/Navbar'
import Footer from '../components/layout/Footer'

export default {
  components: {
    Navbar,
    Footer
  },
  mounted() {
    const wediTheme = () => import('../assets/styles/wedi.scss')
    const appTheme = () => import('../assets/styles/app.scss')

    switch (process.env.VUE_APP_SKIN) {
      case 'wedi':
        wediTheme()
        break
      case 'fivenomics':
      default:
        appTheme()
        break
    }
  }
}
</script>
